import { random } from "gsap/all"
import { Application, Graphics, particles, Sprite, Texture } from "pixi.js"
import { SNOW_PARTICLE } from "../Constants/ImageConstants"
import { RootController } from "../RootController"
import { Random } from "./Math"

const COLOR = 0xffffff
const floored = (o: number) => (Random() * o);


class pSprite extends Sprite {
    vx: number = 0; //velocity
    vy: number = 0;
    nx: number = 0; // normalized x coord
    ny: number = 0;
}

const AMOUNT = 100;
export class FallingSnow extends particles.ParticleContainer {
    public maxSpeedY = 0.05; //нормализованная скорость падения снега
    public maxSpeedXp = 0.01; //движение вправо
    public maxSpeedXn = -0.01; //движение влево
    public maxParticleSize = 20; //максимальный размер в пикселях
    public minParticleSize = 10; //минимальный размер в пикселях
    public maxAlpha = 0.8;
    public amount = AMOUNT;

    private particles: pSprite[] = [];
    public particleWidth: number = 1920;
    public particleHeight: number = 1080;

    constructor(private controller: RootController) {
        super(AMOUNT, {
            scale: true, position: true, alpha: true
        });
    }

    private updateSpeed = (p) => {
        return Math.random() > 0.5 ?
            Math.max(this.maxSpeedXn, p - 1) :
            Math.min(p + 1, this.maxSpeedXp);
    }

    public genParticles(t: PIXI.Texture = PIXI.Texture.from(SNOW_PARTICLE)) {
        // const g = new Graphics(true);
        // g.beginFill(COLOR);
        // g.drawCircle(0, 0, 100);
        // g.endFill;
        // t = g.generateCanvasTexture(0, 1);

        this.removeChildren();
        this.particles = new Array(this.amount).fill(null).map(p => {
            const SIZE = floored(this.maxParticleSize) + this.minParticleSize;
            p = new Sprite(t);
            p.scale.set(SIZE / 100);
            p.vx = floored(this.maxSpeedXp) - this.maxSpeedXp;
            p.vy = floored(this.maxSpeedY);
            p.alpha = floored(this.maxAlpha);
            p.nx = Math.random();
            p.ny = Math.random();
            // p.x = floored(this.particleWidth) - this.particleWidth / 2;
            // p.y = -floored(this.particleHeight) / 2 - SIZE;
            this.addChild(p);
            return p;
        });
    }

    public updateParticles(frameTime: number = 0): void {
        const player = this.controller.$model.currentPlayer;
        this.particles.forEach(particle => {

            particle.nx += particle.vx * frameTime;
            particle.ny += particle.vy * frameTime;

            if (!this.controller.$model.pause) {
                particle.nx += (particle.nx - 0.5) * player.speed / player.speedMax * 0.05;
                particle.ny += (particle.ny - 0.5) * player.speed / player.speedMax * 0.05;
            }

            particle.x = particle.nx * (this.particleWidth) - this.particleWidth / 2;
            particle.y = particle.ny * this.particleHeight - this.particleHeight / 2;

            if (Math.random() > 0.9) {
                particle.vx = this.updateSpeed(particle.vx);
                particle.vy = Math.min(particle.vy + 0.01, this.maxSpeedY)
            }

            if (
                particle.nx > 1 ||
                particle.nx < 0 ||
                particle.ny > 1
            )
                // if (
                //     particle.x > this.particleWidth / 2 ||
                //     particle.x < -this.particleWidth / 2 ||
                //     particle.y > this.particleHeight
                // )
                this.resetParticle(particle);
        });
    }

    public onResize() {

    }

    private resetParticle(p: any) {
        p.nx = Math.random();
        p.ny = Math.random();
        p.vy = floored(this.maxSpeedY);
    };



}

